var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.blank)?_c('a',{attrs:{"href":'#'+_vm.href,"title":_vm.title,"target":"_blank"}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.href,"title":_vm.title}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }